var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1906_1621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73368 9.8408C7.08303 8.69405 6.72226 7.42744 6.65137 6.14777L8.91191 5.87695L9.70783 8.66255L7.73368 9.8408ZM7.73368 9.8408C8.10058 10.4874 8.55964 11.096 9.11091 11.6471C9.66216 12.1984 10.2707 12.6575 10.9172 13.0244M10.9172 13.0244C12.064 13.6751 13.3306 14.0358 14.6102 14.1067L14.8811 11.8461L12.0955 11.0502L10.9172 13.0244Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13943 13.3406C2.58669 12.1777 2.29199 10.8961 2.29199 9.58398C2.29199 7.26334 3.21387 5.03774 4.85481 3.3968C6.49575 1.75586 8.72135 0.833984 11.042 0.833984C13.3627 0.833984 15.5882 1.75586 17.2292 3.3968C18.8702 5.03774 19.792 7.26334 19.792 9.58398C19.792 11.9047 18.8702 14.1302 17.2292 15.7712C15.5882 17.4122 13.3627 18.334 11.042 18.334C9.72991 18.334 8.44821 18.0393 7.28538 17.4866L1.79199 18.834L3.13943 13.3406Z",
    stroke: "#B0B0B0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1906_1621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.ed9c14f48954c058cce09b09e44b4533.svg";
export { ForwardRef as ReactComponent };